import React, { FC, useEffect } from 'react';

import { useFormik } from 'formik';

import { stub } from '@pharmaplan/common/helpers/utils';

import { getProInfo, proInfo } from '@pharmaplan/common';
import { ProfileScreens } from '../../../../helpers/Constants';
import ProfileForm from '../../ProfileForm';
import { useAppSelector } from '../../../../hooks/useAppSelector';
import { useAppDispatch } from '../../../../hooks/useAppDispatch';

export interface ICommonProfile {
  setSelected: React.Dispatch<React.SetStateAction<string>>;
}

const ProfessionalProfileAnalytics: FC<ICommonProfile> = ({ setSelected }) => {
  const dispatch = useAppDispatch();

  const profileAnalytics = useAppSelector(proInfo);
  const { reviewDetails } = profileAnalytics ?? {};
  const { confirmedBookings, arrivals, questionValues, cancellations } = reviewDetails ?? {};

  const fallbackArrivals = questionValues?.reduce(
    (acc: Record<string, number>, curr) => {
      acc[curr.key] = arrivals[curr.key] ?? 0;
      return acc;
    },
    {},
  );

  const formik = useFormik({
    initialValues: {
      ...fallbackArrivals,
      confirmedBookings,
      cancellations,
    },
    onSubmit: stub,
  });

  useEffect(() => {
    dispatch(getProInfo());
  }, []);

  return (
    <ProfileForm
      setSelected={setSelected}
      selected={ProfileScreens.professionalProfileAnalytics}
      formik={formik}
    />
  );
};

export default ProfessionalProfileAnalytics;
